import { render } from "./TradeInfo.vue?vue&type=template&id=9a255b20&scoped=true"
import script from "./TradeInfo.vue?vue&type=script&lang=js"
export * from "./TradeInfo.vue?vue&type=script&lang=js"

import "./TradeInfo.vue?vue&type=style&index=0&id=9a255b20&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a255b20"]])

export default __exports__